module.exports = "/_next/static/images/10-bcc65198f6af8a4fc62c157d813c93a5.png";